import * as React from 'react';
import styled from 'styled-components';
import { Tag, theme, ALL_CONTACT_TAGS, ContactTagType } from 'components';
import { StyledSkeletonInput } from './commonStyled';
import { ContactType } from '../../../../ConfigContactModal/types';

const ContactTypeTag = styled(Tag)`
  border-color: ${theme.blue3};
  color: ${theme.blue6};
  text-transform: capitalize;
  margin: 1px 1px;
  font-weight: 600;
`;

const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
export interface TagsCellProps {
  loading?: boolean;
  tags: string[];
}

const TagsCell: React.FC<TagsCellProps> = ({ loading, tags }) => loading ? (
    <StyledSkeletonInput size="small" />
  ) : (
    <StyledContainer>
      {tags?.map((tag: ContactTagType, i) => (
        <ContactTypeTag key={i} color="blue1">
          {ALL_CONTACT_TAGS[tag]?.label || tag}
        </ContactTypeTag>
      ))}
    </StyledContainer>
  );

export default React.memo(TagsCell);
